/**
 * Admin API for course type Try-as-Guest eligibility (student-service).
 * Requires SYSTEM_ADMIN. Use studentApi so the same JWT is sent.
 */
import studentApi from './studentApi';

const BASE = '/api/admin/course-types';

export interface CourseTypeGuestEligibilityDTO {
  courseType: string;
  displayName: string;
  eligible: boolean;
}

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

export async function listGuestEligibility(): Promise<CourseTypeGuestEligibilityDTO[]> {
  const res = await studentApi.get<ApiResponse<CourseTypeGuestEligibilityDTO[]>>(`${BASE}/guest-eligibility`);
  if (!res.data?.success || !res.data?.data) throw new Error(res.data?.message ?? 'Failed to load');
  return res.data.data;
}

export async function updateGuestEligibility(
  courseType: string,
  eligible: boolean
): Promise<CourseTypeGuestEligibilityDTO> {
  const res = await studentApi.put<ApiResponse<CourseTypeGuestEligibilityDTO>>(`${BASE}/guest-eligibility`, {
    courseType,
    eligible,
  });
  if (!res.data?.success || !res.data?.data) throw new Error(res.data?.message ?? 'Failed to update');
  return res.data.data;
}
